"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.payContractorsEvents = exports.paymentMethodEvents = exports.onboardingEvents = exports.signUpEvents = void 0;

var _constants = require("../../registration/auth/constants");

var signUpEventProps = {
  domain: 'sign_up',
  user_type: _constants.userRole.EMPLOYER
};
var signUpEvents = {
  INIT_SIGN_UP: {
    name: 'sign up started',
    eventProps: signUpEventProps
  },
  GOAL_PROVIDED: {
    name: 'goal provided',
    eventProps: signUpEventProps
  },
  ACCOUNT_CREATED: {
    name: 'account created',
    eventProps: signUpEventProps
  },
  PERSONAL_DETAILS_ADDED: {
    name: 'personal details added',
    eventProps: signUpEventProps
  },
  COMPANY_INFO_ADDED: {
    name: 'company info added',
    eventProps: signUpEventProps
  },
  LEGAL_REPRESENTATIVE_ADDED: {
    name: 'legal representative added',
    eventProps: signUpEventProps
  },
  BILLING_CONTACT_ADDED: {
    name: 'billing contact added',
    eventProps: signUpEventProps
  },
  COMPANY_ADDRESS_ADDED: {
    name: 'company address added',
    eventProps: signUpEventProps
  },
  MSA_SIGNED: {
    name: 'MSA signed',
    eventProps: signUpEventProps
  },
  END_SIGN_UP: {
    name: 'end sign up',
    eventProps: signUpEventProps
  }
};
exports.signUpEvents = signUpEvents;
var onboardingEventProps = {
  domain: 'onboarding'
};
var onboardingEvents = {
  PERSONAL_PROFILE_ADDED: {
    name: 'personal profile added',
    eventProps: onboardingEventProps
  },
  BANK_DETAILS_ADDED: {
    name: 'bank details added',
    eventProps: onboardingEventProps
  },
  ADMINISTRATIVE_DETAILS_ADDED: {
    name: 'administrative details added',
    eventProps: onboardingEventProps
  },
  HOME_ADDRESS_ADDED: {
    name: 'home address added',
    eventProps: onboardingEventProps
  },
  EMERGENCY_CONTACT_ADDED: {
    name: 'emergency contact added',
    eventProps: onboardingEventProps
  },
  IDENTITY_VERIFICATION_DONE: {
    name: 'identity verification finished',
    eventProps: onboardingEventProps
  },
  DOCUMENTATION_ADDED: {
    name: 'supporting documentation added',
    eventProps: onboardingEventProps
  },
  REVIEW_COMPENSATION_DONE: {
    name: 'review compensation done',
    eventProps: onboardingEventProps
  },
  ONBOARDING_END: {
    name: 'onboarding finished',
    eventProps: onboardingEventProps
  }
};
exports.onboardingEvents = onboardingEvents;
var paymentMethodEventProps = {
  domain: 'payment method',
  user_type: _constants.userRole.EMPLOYER
};
var paymentMethodEvents = {
  INIT_SEPA_METHOD: {
    name: 'init SEPA method',
    eventProps: paymentMethodEventProps
  },
  INIT_ACH_METHOD: {
    name: 'init ACH method',
    eventProps: paymentMethodEventProps
  },
  INIT_CARD_METHOD: {
    name: 'init Card method',
    eventProps: paymentMethodEventProps
  },
  CARD_ADDED: {
    name: 'Card added',
    eventProps: paymentMethodEventProps
  },
  CARD_UPDATED: {
    name: 'Card updated',
    eventProps: paymentMethodEventProps
  },
  INIT_ACH_VERIFICATION: {
    name: 'init ACH verification',
    eventProps: paymentMethodEventProps
  },
  ACH_ADDED: {
    name: 'ACH added',
    eventProps: paymentMethodEventProps
  },
  INIT_SEPA_MANDATE: {
    name: 'init SEPA mandate',
    eventProps: paymentMethodEventProps
  },
  SEPA_ADDED: {
    name: 'SEPA added',
    eventProps: paymentMethodEventProps
  },
  PAYMENT_METHOD_SET_DEFAULT: {
    name: 'payment method set default',
    eventProps: paymentMethodEventProps
  },
  PAYMENT_METHOD_DELETED: {
    name: 'payment method deleted',
    eventProps: paymentMethodEventProps
  }
};
exports.paymentMethodEvents = paymentMethodEvents;
var payContractorsEventProps = {
  domain: 'payment contractors',
  user_type: _constants.userRole.EMPLOYER
};
var payContractorsEvents = {
  INIT_ADD_PAYMENT_METHOD: {
    name: 'init add payment method',
    eventProps: payContractorsEventProps
  },
  SKIP_ADDING_PAYMENT: {
    name: 'skip adding payment',
    eventProps: payContractorsEventProps
  },
  INIT_PAYMENT: {
    name: 'init payment',
    eventProps: payContractorsEventProps
  },
  ADD_PAYMENT_METHOD_WHEN_PAYING: {
    name: 'add payment method when paying',
    eventProps: payContractorsEventProps
  },
  INIT_PAYMENT_CONFIRMATION: {
    name: 'init payment confirmation',
    eventProps: payContractorsEventProps
  },
  PAYMENT_CONFIRMED: {
    name: 'payment confirmed',
    eventProps: payContractorsEventProps
  },
  PAYMENT_FAILED: {
    name: 'payment failed',
    eventProps: payContractorsEventProps
  },
  INIT_INVOICE_DECLINE: {
    name: 'init invoice decline',
    eventProps: payContractorsEventProps
  },
  INVOICE_DECLINED: {
    name: 'invoice declined',
    eventProps: payContractorsEventProps
  }
};
exports.payContractorsEvents = payContractorsEvents;